export default __webpack_public_path__ + "images/picture-sun.6cb4400d87e88b33408eb54ca5b22418.svg";